import React, {useContext} from 'react';

const CustomerListContext = React.createContext();

export const useCustomerListContext = () => useContext(CustomerListContext);

export default CustomerListContext;
